/**
 * SHA-256 of a file as it is read, in pieces: Web Crypto only hashes whole
 * buffers, and a recording can be many gigabytes.
 *
 * @module
 */
import init, { Sha256 } from "./hash/avgv_hash_wasm.js";
import wasmUrl from "./hash/avgv_hash_wasm_bg.wasm?url";

let ready: Promise<unknown> | null = null;

/** Lower-case hex; `onRead` is called with each piece's length. */
export async function sha256Of(
  file: File,
  onRead?: (bytes: number) => void,
): Promise<string> {
  ready ??= init({ module_or_path: wasmUrl });
  await ready;
  const hasher = new Sha256();
  try {
    const reader = file.stream().getReader();
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      hasher.update(value);
      onRead?.(value.length);
    }
    return hasher.finish();
  } finally {
    hasher.free();
  }
}
